import React from "react";
import { Col, Row } from "react-bootstrap";
const Footer = () => {
	return (
		<footer className='footer'>
			<div className='page-container'>
				<Row>
					<Col md={6} className='text-center text-md-start'>
						© 24agency.ro Management Intern - By{" "}
						<span className='fw-bold text-decoration-underline text-uppercase text-reset fs-12'>
							Dennis
						</span>
					</Col>
					
				</Row>
			</div>
		</footer>
	);
};
export default Footer;
